import axios from 'axios';
import { ENDPOINTS } from './Endpoints';
import { colorNormalize } from '../Objetos/ColoresModel';
import { getSessionUserId } from '../../../utils/SessionUser';
import { ENDPOINTS as GENERAL_ENDPOINTS } from '../../General/Utils/Endpoints';

/**
 * Aplica una variable CSS individual al :root del documento.
 * @param {string} variable - El nombre de la variable (ej. --color-primary)
 * @param {string} valor - El valor de la variable (ej. #3c00be)
 */
export const applyIndividualVariable = (variable, valor) => {
    if (!variable || !valor) return;

    const root = document.documentElement;
    if (variable.startsWith('--')) {
        root.style.setProperty(variable, valor);
    }
};



/**
 * Carga todos los colores activos desde la base de datos y los inyecta en el CSS global.
 * Este proceso convierte cada registro de la BD en una variable CSS real en el :root.
 * Soporta Multi-Tenancy: Busca la empresa del usuario logueado.
 */
export const loadAndApplyActiveTheme = async () => {
    try {
        // console.log('[ThemeManager] Sincronizando variables de identidad visual...');

        let idEmpresa = null;
        const idUsuario = getSessionUserId();

        if (idUsuario) {
            try {
                const resEmpresas = await axios.get(GENERAL_ENDPOINTS.empresasUsuario(idUsuario));
                const empresas = resEmpresas.data || [];
                if (empresas.length > 0) {
                    // Tomamos la primera empresa activa del usuario (la principal)
                    idEmpresa = empresas[0].idEmpresa || empresas[0].IdEmpresa;
                    // console.log(`[ThemeManager] Usuario ${idUsuario} pertenece a empresa ${idEmpresa}. Cargando tema personalizado...`);
                }
            } catch (e) {
                console.warn('[ThemeManager] No se pudo obtener la empresa del usuario, cargando tema default.', e);
            }
        } else {
            // console.log('[ThemeManager] Sin sesión activa (Login/Home). Cargando tema Default inmediato.');
        }

        // Llamada al endpoint con el parámetro opcional idEmpresa
        const endpoint = idEmpresa
            ? `${ENDPOINTS.colores}?idEmpresa=${idEmpresa}`
            : ENDPOINTS.coloresDefault;

        const res = await axios.get(endpoint);

        // Normalizamos los datos que vienen del API
        const colors = (res.data || []).map(x => colorNormalize(x));

        // Filtramos solo los que están activos y tienen variable definida
        const activeColors = colors.filter(c => c.activo && c.variable);

        if (activeColors.length > 0) {
            activeColors.forEach(color => {
                applyIndividualVariable(color.variable, color.valor);
            });
            // console.log(`[ThemeManager] Se han aplicado ${activeColors.length} variables de color desde la base de datos.`);
        } else {
            console.warn('[ThemeManager] No se encontraron variables de color activas en la base de datos.');
        }
    } catch (error) {
        console.error('[ThemeManager] Error crítico al cargar variables de identidad:', error);
    }
};

/**
 * Función legacy para mantener compatibilidad si se sigue usando JSON en algún punto,
 * aunque la nueva estructura de un-registro-por-color es la preferida.
 * @param {Object} vars 
 */
export const applyThemeVariables = (vars) => {
    if (!vars || typeof vars !== 'object') return;
    const root = document.documentElement;
    Object.entries(vars).forEach(([key, value]) => {
        if (key.startsWith('--')) {
            root.style.setProperty(key, value);
        }
    });
};
